module.exports =  {
    login: {
        loginhello:"Hello",
        loginTitle: "Welcome Sign In",
    }
}
